import { sendToNative } from '@mobi/web-native-comms/web'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import type { Contract } from '@mobi/web-native-comms'

export function trackOptimoveEvent(event: Contract['OPTIMOVE_TRACK']) {
  trackEvent('optimove_track', event)
  sendToNative('OPTIMOVE_TRACK', event)
}
